import React from 'react';
import { MessageSquare } from 'lucide-react';
import { format } from 'date-fns';

const NotesCard = ({ notes, onAddNote }) => (
  <div className="bg-surface border border-border rounded-lg p-4" data-testid="notes-card">
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-lg font-heading font-semibold text-text-primary">Notes</h2>
      <button
        onClick={onAddNote}
        className="flex items-center gap-1 px-3 py-1.5 text-sm bg-surface-highlight text-text-primary rounded-md hover:bg-border transition-colors"
        data-testid="add-note-btn"
      >
        <MessageSquare size={16} />
        Add Note
      </button>
    </div>
    {notes.length === 0 ? (
      <p className="text-text-secondary text-sm">No notes added yet</p>
    ) : (
      <div className="space-y-3">
        {notes.map((note) => (
          <div key={note.id} className="p-3 bg-background rounded-md border border-border">
            <p className="text-text-primary text-sm">{note.content}</p>
            <p className="text-xs text-text-secondary mt-2">
              {note.user_name} - {format(new Date(note.timestamp), 'MMM d, yyyy h:mm a')}
            </p>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default NotesCard;
